import React, { Component, PropTypes } from 'react'
import { AutoSizer, VirtualScroll } from 'react-virtualized'
import cn from 'classnames'
import { EasinsureClaimsListItem } from './EasinsureClaimsListItem'
import styles from './EasinsureClaimsList.scss'
import clientStyles from 'elements/client.scss'
import 'react-virtualized/styles.css'

export class EasinsureClaimsList extends Component {
    constructor(props) {
        super(props)
        this.rowRenderer = this.rowRenderer.bind(this)
    }

    rowRenderer({ index }) {
        const { claimsList, onSelectClaimClicked } = this.props
        const { claimMain } = claimsList[index]

        return (
            <EasinsureClaimsListItem
                key={index}
                claimMain={claimMain}
                onClaimClicked={onSelectClaimClicked.bind(null, claimMain.claimNumber)}
            />
        )
    }

    render() {
        const { claimsList, breakpoint: { isPhone } } = this.props

        return (
            <div className={cn(clientStyles.listWrapper, styles.claimsList)}>
                <AutoSizer>
                    {({width, height}) => (
                        <VirtualScroll
                            className={clientStyles.list}
                            height={height}
                            width={width}
                            rowCount={claimsList.length || 0}
                            rowHeight={isPhone ? 140 : 120}
                            rowRenderer={this.rowRenderer}
                        />
                    )}
                </AutoSizer>
            </div>
        )
    }
}
EasinsureClaimsList.propTypes = {
    claimsList: PropTypes.array,
    breakpoint: PropTypes.object,
    onSelectClaimClicked: PropTypes.func,
}



// WEBPACK FOOTER //
// ./components/easinsure/claims/EasinsureClaimsList.jsx